import { axiosBaseQuery } from "@src/service";
import { UserEntity, UserRoleType } from '@src/core/features/profile/entities';
import { createApi } from '@reduxjs/toolkit/query/react';

export const baseProfileApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'baseProfileApi',
  tagTypes: ['Profile'],
  endpoints: (builder) => ({
    getUserData: builder.query<UserEntity, void>({
      query: () => ({
        url: '/api/v1/user/profile',
        method: 'GET',
      }),    
      providesTags: ['Profile'],
      transformResponse: (response: UserEntity) => {
        const role = response.role;
        return {
          ...response,
          roleStatus: {
            isAdmin: role === UserRoleType.ADMIN || role === UserRoleType.OWNER,
            isViewer: role === UserRoleType.VIEWER,
            isAnalyst: role === UserRoleType.ANALYST,
            isOperator: role === UserRoleType.OPERATOR,
            isSuperAdmin: role === UserRoleType.SUPERADMIN,
          }
        };
      }
    }),
  })
});


export const { useGetUserDataQuery } = baseProfileApi;